// extracted by mini-css-extract-plugin
module.exports = {"paginator":"_2s5tQed"};